export const generalDropdownValues = {
	supportOption: [
		{
			name: "Bronze",
			value: 1,
		},
		{
			name: "Silver",
			value: 2,
		},
		{
			name: "Gold",
			value: 3,
		},
	],
};

export const generalConstants = {
	MERCHANT_GET_GENERAL_DATA_ERROR: "MERCHANT_GET_GENERAL_DATA_ERROR",
	MERCHANT_GET_GENERAL_DATA_SUCCESS: "MERCHANT_GET_GENERAL_DATA_SUCCESS",
	MERCHANT_GET_GENERAL_DATA_REQUEST: "MERCHANT_GET_GENERAL_DATA_REQUEST",

	MERCHANT_UPDATE_GENERAL_DATA_REQUEST:
		"MERCHANT_UPDATE_GENERAL_DATA_REQUEST",
	MERCHANT_UPDATE_GENERAL_DATA_SUCCESS:
		"MERCHANT_UPDATE_GENERAL_DATA_SUCCESS",
	MERCHANT_UPDATE_GENERAL_DATA_ERROR: "MERCHANT__UPDATE_GENERAL_DATA_ERROR",

	MERCHANT_ADD_REQUEST: "MERCHANT_ADD_REQUEST",
	MERCHANT_ADD_SUCCESS: "MERCHANT_ADD_SUCCESS",
	MERCHANT_ADD_ERROR: "MERCHANT_ADD_ERROR",

	MERCHANT_SET_MID_VALIDATION_PENDING: "MERCHANT_SET_MID_VALIDATION_PENDING",
	MERCHANT_VALIDATE_MID_REQUEST: "MERCHANT_VALIDATE_MID_REQUEST",
	MERCHANT_VALIDATE_MID_SUCCESS: "MERCHANT_VALIDATE_MID_SUCCESS",
	MERCHANT_VALIDATE_MID_ERROR: "MERCHANT_VALIDATE_MID_ERROR",

	MERCHANT_SET_ORIGINAL_MID_VALIDATION_PENDING:
		"MERCHANT_SET_ORIGINAL_MID_VALIDATION_PENDING",
	MERCHANT_VALIDATE_ORIGINAL_MID_REQUEST:
		"MERCHANT_VALIDATE_ORIGINAL_MID_REQUEST",
	MERCHANT_VALIDATE_ORIGINAL_MID_SUCCESS:
		"MERCHANT_VALIDATE_ORIGINAL_MID_SUCCESS",
	MERCHANT_VALIDATE_ORIGINAL_MID_ERROR:
		"MERCHANT_VALIDATE_ORIGINAL_MID_ERROR",

	MERCHANT_SET_DISCOVER_MID_VALIDATION_PENDING:
		"MERCHANT_SET_DISCOVER_MID_VALIDATION_PENDING",
	MERCHANT_VALIDATE_DISCOVER_MID_REQUEST:
		"MERCHANT_VALIDATE_DISCOVER_MID_REQUEST",
	MERCHANT_VALIDATE_DISCOVER_MID_SUCCESS:
		"MERCHANT_VALIDATE_DISCOVER_MID_SUCCESS",
	MERCHANT_VALIDATE_DISCOVER_MID_ERROR:
		"MERCHANT_VALIDATE_DISCOVER_MID_ERROR",

	MERCHANT_SET_BANKS: "MERCHANT_SET_BANKS",
	MERCHANT_SET_BILLING_BANKS: "MERCHANT_SET_BILLING_BANKS",

	MERCHANT_ADD_BRANDING_LOGO_SUCCESS: "MERCHANT_ADD_BRANDING_LOGO_SUCCESS",
	MERCHANT_ADD_BRANDING_LOGO_ERROR: "MERCHANT_ADD_BRANDING_LOGO_ERROR",
	MERCHANT_DELETE_BRANDING_LOGO_SUCCESS:
		"MERCHANT_DELETE_BRANDING_LOGO_SUCCESS",
	MERCHANT_DELETE_BRANDING_LOGO_ERROR: "MERCHANT_DELETE_BRANDING_LOGO_ERROR",
	SET_MERCHANT_LOGO: "SET_MERCHANT_LOGO",

	LOAD_SALES_AGENTS_REQUEST: "LOAD_SALES_AGENTS_REQUEST",
	LOAD_SALES_AGENTS_SUCCESS: "LOAD_SALES_AGENTS_SUCCESS",
	LOAD_SALES_AGENTS_FAILURE: "LOAD_SALES_AGENTS_FAILURE",

	LOAD_REFERRAL_PARTNERS_REQUEST: "LOAD_REFERRAL_PARTNERS_REQUEST",
	LOAD_REFERRAL_PARTNERS_SUCCESS: "LOAD_REFERRAL_PARTNERS_SUCCESS",
	LOAD_REFERRAL_PARTNERS_FAILURE: "LOAD_REFERRAL_PARTNERS_FAILURE",

	MERCHANT_GET_HIERARCHY_REQUEST: "MERCHANT_GET_HIERARCHY_REQUEST",
	MERCHANT_GET_HIERARCHY_SUCCESS: "MERCHANT_GET_HIERARCHY_SUCCESS",
	MERCHANT_GET_HIERARCHY_ERROR: "MERCHANT_GET_HIERARCHY_ERROR",

	MERCHANT_SET_HIGH_RISK: "MERCHANT_SET_HIGH_RISK",
};
